export enum SearchNavigationPaths {

  BUILDING = 'building',
  INSTALL_EQUIPMENT = 'install-equipment',
  INSTALL_EQUIPMENT_FEATURE = 'install-equipment-feature',
  INSTALL_MODULE = 'install-module',
  INSTALL_MODULE_FEATURE = 'install-module-feature'

}
